import { gql } from 'apollo-boost';

const saveSelfieId = gql`
  mutation saveSelfieId($request : SaveSelfieIdRequestType!) {
    saveSelfieId(request: $request) {
      success
    }
  }
`;

export default saveSelfieId;